{
  "hi": {
    "title": "Индикаторы здоровья",
    "popover": {
      "openCiHealth": "Открыть здоровье КЕ →",
      "loadedCount": "{{loaded}} из {{total}} КЕ",
      "empty": "Нет активных индикаторов",
      "loadError": "Не удалось загрузить индикаторы"
    },
    "tabs": {
      "activeHI": "Активные ИЗ",
      "history": "История изменений"
    },
    "table": {
      "title": "Верхнеуровневые ИЗ",
      "filters": {
        "hiFilterPlaceholder": "Выберите ИЗ",
        "changeStatus": "Дата создания"
      },
      "columns": {
        "ci": "КЕ",
        "hi": "ИЗ",
        "value": "Критичность",
        "change_status": "Создан",
        "finished_at": "Завершен",
        "started_at": "Создан",
        "duration": "Длительность",
        "summary": "Сводка",
        "labels": "Лейблы",
        "annotations": "Аннотации",
        "type": {
          "title": "Тип"
        },
        "description": "Описание",
        "template": "Шаблон"
      }
    },
    "alerts": {
      "closeAction": "Закрыть алерт",
      "closeSelected": "Закрыть выбранные алерты ({{count}})",
      "forceCloseTitle": "Подтвердите закрытие алертов",
      "forceCloseDescription": "Алерт или часть выбранных алертов закрываются автоматически. Закрыть принудительно?",
      "forceCloseConfirm": "Закрыть принудительно",
      "closeError": "Не удалось закрыть алерты",
      "closePartialError_one": "Не удалось закрыть {{count}} алерт: {{messages}}",
      "closePartialError_few": "Не удалось закрыть {{count}} алерта: {{messages}}",
      "closePartialError_many": "Не удалось закрыть {{count}} алертов: {{messages}}",
      "closePartialError_other": "Не удалось закрыть {{count}} алерта: {{messages}}"
    }
  },
  "srm": {
    "types": {
      "CHANGED_ATTRIBUTE": "Атрибут изменен",
      "CREATE_CI": "Создан КЕ",
      "DELETE_CI": "Удален КЕ"
    }
  },
  "config": {
    "title": "Состояние сервера",
    "tabs": {
      "backgroundTasks": "Фоновые задачи",
      "history": "История изменений"
    },
    "types": {
      "HI_LINK_ON": "ИЗ включен",
      "HI_LINK_OFF": "ИЗ выключен",
      "METRIC_ON": "Метрика включена",
      "METRIC_OFF": "Метрика выключена",
      "ADD_USER": "Добавлен пользователь",
      "DELETE_USER": "Удален пользователь",
      "SERVICE_UP": "Сервис включен",
      "SERVICE_DOWN": "Сервис выключен",
      "SRM_UP": "СРМ запущен",
      "SRM_DOWN": "СРМ отключен"
    }
  },
  "table": {
    "new": "Новых",
    "groupBy": "Группировать по",
    "total": "Всего",
    "timeRanges": {
      "minutes": "мин.",
      "hours": "ч.",
      "days": "дн.",
      "weeks": "нед.",
      "months": "мес.",
      "years": "г."
    }
  },
  "general": {
    "noDefaultDashboards": "Не удалось найти дашборд по умолчанию",
    "defaultDashboards": "Дашборды по умолчанию"
  },
  "log": {
    "title": "Уведомления",
    "state": "Состояние",
    "empty": "Нет новых уведомлений",
    "counters": {
      "total": "Записей в импорте",
      "created": "Создано КЕ",
      "modified": "Изменено КЕ",
      "unchanged": "КЕ без изменений",
      "skipped": "Пропущено КЕ",
      "deleted": "Удалено КЕ",
      "not_found": "КЕ не найдено",
      "errors": "Ошибки КЕ",
      "links_created": "Создано связей"
    }
  },
  "subscriptions": {
    "title": "Подписки",
    "fields": {
      "enable": "Включить",
      "name": "Название",
      "label": "Отображаемое имя",
      "receiver": "Получатель",
      "resolve": "Необходимо разрешение",
      "groupBy": "Группировать уведомления",
      "groupWait": "Интервал создания группы",
      "groupInterval": "Интервал расширения группы",
      "repeatInterval": "Интервал напоминания",
      "bellSubscribe": "Получать уведомления в браузере",
      "extendedFilter": "Расширенный фильтр событий"
    },
    "unsavedChanges": "Есть несохраненные изменения. Продолжить?",
    "editNotifications": "Настроить уведомления",
    "new": "Новая подписка"
  },
  "senders": {
    "deleteTitle": "Внимание! Вместе с отправителем будут удалены <br/>все связанные с ним <strong>неактивные</strong> получатели. Продолжить?"
  },
  "receivers": {
    "deleteTitle": "Внимание! Удаление этого адресата приведет к исключению <br/>его из всех связанных подписок. Продолжить?"
  }
}
